import { render, staticRenderFns } from "./ClientDocumentGroupsTable.vue?vue&type=template&id=61233214&scoped=true&"
import script from "./ClientDocumentGroupsTable.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentGroupsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocumentGroupsTable.vue?vue&type=style&index=0&id=61233214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61233214",
  null
  
)

export default component.exports